module.exports = __webpack_public_path__ + "static/media/icon-city.cbc17d15.svg";